












import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import HostPageLinkMixin from '@/mixin/HostPageLink'

@Component({
  mixins: [
    HostPageLinkMixin,
  ],
})
export default class AboutMyColorBase extends Vue {
  @Prop({ default: 'div' })
  tag: string
}
